export default __webpack_public_path__ + "static/media/Matthew.6e336255.png";